import React, { useMemo } from 'react'
import { CustomTable, Button, Loading } from 'src/components'
import { Link, useNavigate } from 'react-router-dom'
import ROUTES from 'src/constants/routes'
import { PageTitle } from 'src/components/PageTitle'
import { useStyles } from './styles'
import { more } from 'src/assets/png'
import { Filter } from 'src/assets/svg'
import { useFilterToggler } from 'src/components/CustomTable/hooks/useFilterToggler'
import { useBreedingListTableHeader } from './hooks/useBreedingListTableHeader'
import { useGetPregnancyDiagnosisList } from 'src/hooks/api/pregnancy-diagnosis'

export const BreedingList: React.FC = () => {
  const navigate = useNavigate()
  const style = useStyles()
  const { tableHeader } = useBreedingListTableHeader()
  const { filterIsActive, handleFilter } = useFilterToggler()

  const { data: pregnancyDiagnosisData = [], isLoading } = useGetPregnancyDiagnosisList()

  const list = useMemo(() => {
    return pregnancyDiagnosisData.filter((item) => item.acao !== 'Removido') || []
  }, [pregnancyDiagnosisData])

  return (
    <>
      <div className={style.propertiesHeader}>
        <PageTitle
          title='Processo de Cobertura'
          className={style.propertiesTitle}
          breadcrumbLink={{
            to: ROUTES.REPRODUCTION.ROOT,
            text: 'Reprodução'
          }}
        >
          <div className={style.buttonContainer}>
            <Button className={`${style.buttonOutlined} ${style.buttonWrapper}`} onClick={handleFilter} outlined>
              <Filter className='icon' />
              Filtrar
            </Button>
            <Link to={ROUTES.REPRODUCTION.COVERAGE_PROCESS.NEW} className={style.buttonWrapper}>
              <Button disabled={isLoading} className={style.buttonWrapper}>
                <img src={more} alt='Incluir' />
                Cadastrar Casal
              </Button>
            </Link>
          </div>
        </PageTitle>
      </div>

      <div className={style.propertiesContainer}>
        {isLoading ? (
          <Loading />
        ) : (
          <CustomTable
            header={tableHeader}
            body={list}
            filterIsActive={filterIsActive}
            onClickItem={(value) =>
              navigate(ROUTES.REPRODUCTION.toPregnancyListDetails(value.idFazenda, value.idAnimal, value.idDiagGest))
            }
            propertiesToFilter={['nomeVaca', 'nomeTouro', 'reproducao', 'dataInicio', 'tipoMonta', 'inseminador']}
          />
        )}
      </div>
    </>
  )
}
